<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Tambah Dokumen
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4 mt-2">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama File" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama File
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Lampiran"

                      hide-details

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <div>
                    <div v-if="form.url === ''">
                        <uploaddocument 
                          v-model="upload.document">
                          <div 
                            slot="activator">
                            <v-card
                              flat
                              class="cursor-pointer"
                              style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                              <v-card-text
                                class="py-2">
                                <div v-if="!process.document"
                                  class="d-flex align-center justify-center">
                                  <v-icon 
                                    size="28" 
                                    color="#b6b6b6">
                                    mdi-cloud-upload-outline
                                  </v-icon>

                                  <div
                                    class="black--text ml-2"
                                    style="opacity: 40%; font-weight: 500;">
                                    Upload File
                                  </div>
                                </div>

                                <div v-if="process.document"
                                  class="text-center">
                                  <v-progress-circular
                                    indeterminate
                                    size="28"
                                    color="#b6b6b6">
                                  </v-progress-circular>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </uploaddocument>
                      </div>

                      <div v-if="form.url !== ''">
                        <v-card
                          flat
                          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                          <v-icon
                            @click="form.url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>

                          <v-card-text
                            class="py-3 line-text-second">
                            <div
                              class="">
                              <div style="width: 50px;">File</div> 
                              <div>
                                {{ form.url }}
                              </div>
                            </div>

                            <!-- <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                            </div> -->
                          </v-card-text>
                        </v-card>
                      </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Dokumen
                    </span>
                  </div>

                  <v-spacer />

                  <div class="d-flex align-center" v-if="user.role === 'admin'">
                    <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1 pt-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; height: calc(100vh - 170px); overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <div>
                    <div>
                      <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                        <tr>
                          <th v-if="user.role === 'admin'" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                            Aksi
                          </th>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                            Link
                          </th>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                            Nama
                          </th>
                        </tr>
                        <tr v-for="(item, index) in document" :key="index">
                          <td v-if="user.role === 'admin'" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id)"
                                  v-bind="attrs"
                                  v-on="on"
                                  
                                  min-width="24" min-height="24"
                                  x-small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Hapus</span>
                            </v-tooltip>
                          </td>
                          <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center;" class="black--text">

                            <div>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :href="item.url"
                                    target="_blank"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    :color="extension(item.url) === 'image' ? 'indigo' : extension(item.url) === 'pdf' ? '#b40c1d' : extension(item.url) === 'doc' || extension(item.url) === 'docx' ? '#1b58b8' : '#097640'"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">{{ extension(item.url) === 'image' ? 'mdi-image-area' : extension(item.url) === 'pdf' ? 'mdi-file-pdf' : extension(item.url) === 'doc' || extension(item.url) === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                  </v-btn>
                                </template>

                                <span>Download</span>
                              </v-tooltip>
                            </div>
                          </td>
                          <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                            {{ item.name }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          delete: false,
          form: false
        },

        unit: [],

        form: {
          name: '',
          url: ''
        },
        selected: {
          row: [],
          delete: []
        },
        document: [],

        upload: {
          document: false
        },

        process: {
          load: false,
          form: false,

          document: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_name.vue')
    },
    watch: {
      'form.unit_id' (val) {
        let unit = this.unit.find(x => x.id === val)

        if (unit) {
          this.form.unit_name = unit.title
          this.form.unit_asisten = unit.asisten
        }
      },

      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              // var extension = this.upload.document.data.file_url.match(regexp);
              // this.all_document.push({
              //   url: this.upload.document.data.file_url,
              //   type: extension && extension[1],
              //   name: this.upload.document.data.file_name
              // })
              this.form.url = this.upload.document.data.file_url

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.doc.data.file_url
            }
          }
        },
        deep: true
      },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      mount () {
        return new Date(this.$store.state.dpa.perubahan_date).getMonth() + 1
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000
        }
        
        await get('admin/lampiran/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.document = res.results.data
          }
        })
      },

      extension (url) {
        return url.split('.').pop()
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          name: '',
          url: ''
        }

        this.process.form = false

        this.message.error = ''
      },


      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'admin/lampiran/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              name: this.form.name,
              url: this.form.url
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/lampiran/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>